import {emitEventLog} from '@di-shared/features/analytics';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import LinkTo from '@di-shared/features/navigate/LinkTo';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface VehicleCertificationGradeKrProps {
  vin: string;
  isExtended: boolean;
}

function VehicleCertificationGradeKr({vin, isExtended}: VehicleCertificationGradeKrProps) {
  const {t} = useInferableTranslation();
  return (
    <li className="car_diagnosis_item">
      <LinkTo
        className="car_diagnosis_link"
        to={ROUTE_PATHS.CPO.getFullPath(vin)}
        onClick={() => {
          emitEventLog({
            event: 'vehicle_status_check',
            interaction_type: 'view vehicle certification',
            click_text: t('T20078'),
            click_location: 'body',
          });
        }}
      >
        <div className="section_container">
          <strong className="car_diagnosis_title">{t('T20078')}</strong>
          {isExtended && <span className="car_diagnosis_desc">{t('T30386')}</span>}
          <span className="ic ic_certification"></span>
        </div>
      </LinkTo>
    </li>
  );
}

export default VehicleCertificationGradeKr;
